import {
	getChannelAdmins,
	deleteChannel,
	subscribeChannel,
	unsubscribeChannel,
	changeChannelOwner,
	fetchPendingParticipants,
	requestAccessToPrivateChannel,
	UserServiceClientApi,
} from "../../services/api/UserApiServices";
import webSocketApiService from "../../services/socket/wsApiServices";

import {
	getTimeLine,
	parseMessages,
	removeConversationFromFavourites,
	updateTimeLine,
} from "./chats";

export const CHANNELS_RECEIVED = "CHANNELS_RECEIVED";
export const SUBSCRIBED_CHANNELS_RECEIVED = "SUBSCRIBED_CHANNELS_RECEIVED";
export const UPDATE_CHANNEL = "UPDATE_CHANNEL";
export const UPDATE_FILTERS = "UPDATE_FILTERS";
export const CLEAR_FILTERS = "CLEAR_FILTERS";
export const UPDATE_CHANNEL_SEARCH_KEY = "UPDATE_CHANNEL_SEARCH_KEY";

export function filterChannels(channels, filters, searchKey, user) {
	let filtered = channels;
	if (searchKey) {
		filtered = channels.filter((channel) => {
			let name = channel.channelName.toLowerCase();
			let description = channel.description.toLowerCase();
			searchKey = searchKey.toLowerCase();
			return (
				name.indexOf(searchKey) !== -1 || description.indexOf(searchKey) !== -1
			);
		});
		return filtered;
	}
	// if (filters) {
	//   return filtered.filter(channel => {
	//     let f = true;
	//
	//     let subscribed = filters.subscribed.value,
	//       created = filters.created.value,
	//       unsubscribed = filters.unsubscribed.value,
	//       team = filters.team.value,
	//       platform = filters.platform.value,
	//       publicChannel = filters.publicChannel.value;
	//
	//     if (subscribed) {
	//       f = f && !!channel.subscribed;
	//     }
	//     if (created) {
	//       f =
	//         f &&
	//         channel.channelOwner &&
	//         channel.channelOwner.userId === user.userId;
	//     }
	//     if (unsubscribed) {
	//       f = f && !!!channel.subscribed;
	//     }
	//     if (team) {
	//       // let index = user.domains.findIndex(d => {
	//       //   return d.domain === channel.userDomain;
	//       // });
	//       // f = f && index !== -1;
	//       f = f && channel.userDomain === team;
	//     }
	//     if (platform) {
	//       f = f && channel.userDomain === "frontmai";
	//     }
	//     if (publicChannel) {
	//       f = f && channel.channelType === "public";
	//     }
	//
	//     return f;
	//   });
	// }
	else {
		const filteredChannels = filtered?.filter((channel) => {
			let f = true;
			f = f && !!channel.subscribed;
			return f;
		});
		return filteredChannels;
	}
}
export function fetchAllChannels(selectedDomain) {
	// console.log("fetch all domain ", selectedDomain);
	return (dispatch, getState) => {
		let domain = getState();
		// let domains = getState().user.user.domains;
		// let filters = getState().channels.filters;
		let selectedDomainObj = {
			selectedDomain: selectedDomain,
		};
		Promise.all([
			webSocketApiService.GetSubscribed(selectedDomainObj),
			webSocketApiService.GetUnsubscribed(selectedDomainObj),
		]).then((response) => {
			 if(response[0]?.data?.content){
				dispatch({
				type: CHANNELS_RECEIVED,
				data: {
					channels: response[0].data.content,
					// subscribed: subscribed,
				},
			});
			 }
		
		});
	};
}

export function updateChannelList(rawMessage) {
	return (dispatch, getState) => {
		const allSubscibedChannels = getState().subscribed;
		const parsed_message = parseMessages(rawMessage);
		const channel = parsed_message[0].message;
		const channelDetails = { ...channel };

		switch (parseInt(rawMessage.contentType)) {
			case 11001:
				console.log(
					"added to new channel",
					channelDetails,
					allSubscibedChannels
				);
				break;
			case 11002:
				console.log(
					"unsubscribe to channel",
					channelDetails,
					allSubscibedChannels
				);
				break;
		}
	};
}

export function getPendingParticipants(channel) {
	return (dispatch, getState) => {
		let payload = {
			channelName: channel.channelName,
			userDomain: channel.userDomain,
		}
		webSocketApiService.GetPendingParticipants(payload).then(
			(data) => {
				// console.log("get all pending request ", data);
				dispatch({
					type: UPDATE_CHANNEL,
					data: { channel, pendingRequests: [...data] },
				});
			}
		);
	};
}

export function fetchSubscribedChannels(domainSelected) {
	return (dispatch, getState) => {
		// let domains = getState().user.user.domains;
		// console.log("fetchSubscribedChannels ====== ", domainSelected);
		webSocketApiService.GetSubscribed(domainSelected).then((data) => {
			let subscribed = data.content
			const updatedTimelineList = getState().chats?.timeLine?.map((item) => {
				if (
					item?.channel?.channelName &&
					subscribed?.channelName &&
					item.channel.channelName === subscribed?.channelName
				) {
					return { ...item, ...subscribed };
				}

				return item;
			});

			dispatch(updateTimeLine(updatedTimelineList));

			dispatch({
				type: SUBSCRIBED_CHANNELS_RECEIVED,
				data: { channels: subscribed },
			});
		});
	};
}

export function doSubscribeChannel(channel) {
	// console.log("channle details", channel);

	let domainChannels = [
		{ userDomain: channel.userDomain, channels: [channel.channelName] },
	];
	return (dispatch, getState) => {
		subscribeChannel(domainChannels).then((data) => {
			channel.subscribed = true;
			dispatch({
				type: UPDATE_CHANNEL,
				data: { channel, subscribed: true },
			});
		});
	};
}

export function doUnsubscribeChannel(channel, callback) {
	return (dispatch, getState) => {
		unsubscribeChannel(channel.userDomain, channel.channelName)
			.then((data) => {
				if (data.error && data.error !== "0") {
					console.error("there is an error");
					throw { error: data.error };
				}

				channel.subscribed = false;

				dispatch({
					type: UPDATE_CHANNEL,
					data: { channel, subscribed: false },
				});
				dispatch(getTimeLine());
			})
			.catch((err) => {
				console.log("through user doUnsubscribeChannel", err);
				callback(err);
			});
	};
}

export function createChannel(channelData, callback) {
	return (dispatch) => {
		webSocketApiService.Create(channelData)
			.then((data) => {
				// dispatch(fetchCreatedChannels());
				callback(null);
			})
			.catch((err) => {
				callback(err);
			});
	};
}

export function deleteMyChannel(channelData, callback) {
	return (dispatch) => {
		deleteChannel(channelData)
			.then((data) => {
				callback(null);
			})
			.catch((err) => {
				callback(err);
			});
	};
}

export function changeOwner(channelData, callback) {
	return (dispatch) => {
		changeChannelOwner(channelData)
			.then((data) => {
				callback(null);
			})
			.catch((err) => {
				callback(err);
			});
	};
}

export function channelAdmins(channel) {

	const payload = {
		channelName: channel.channelName,
		userDomain: channel.userDomain,
	};
	return (dispatch, getState) => {
		getChannelAdmins(payload)
			.then((data) => {
				if (data.error && data.error !== "0") {
					console.error("there is an error");
					throw { error: data.error };
				}

				dispatch({
					type: UPDATE_CHANNEL,
					data: { channel, channelAdmins: data },
				});
			})
			.catch((err) => {
				return err;
			});
	};
}

export function subscriptionRequest(channel, callback) {
	return (dispatch) => {
		requestAccessToPrivateChannel(channel).then((data) => {
			dispatch({
				type: UPDATE_CHANNEL,
				data: { channel, requestSent: true },
			});
		});
	};
}

// export function fetchingPendingParticipants(channel){
//   return
// }

export function updateChannelSearchKey(searchKey) {
	return {
		type: UPDATE_CHANNEL_SEARCH_KEY,
		data: { searchKey },
	};
}

export function applyFilters(filters) {
	// console.log("we will se +++++++++++++++", filters);

	return {
		type: UPDATE_FILTERS,
		data: { filters },
	};
}

export function clearFilters() {
	return {
		type: CLEAR_FILTERS,
		data: {},
	};
}
